import maplibregl from "maplibre-gl";
import "maplibre-gl/dist/maplibre-gl.css";

export const map = () => {
  const mapElement = document.getElementById("map");

  if (mapElement) {
    console.log("map is in the page");
    const lat = parseFloat(mapElement.dataset.lat) || 0;
    const lng = parseFloat(mapElement.dataset.lng) || 0;
    const zoom = parseFloat(mapElement.dataset.zoom) || 10;

    const mapInstance = new maplibregl.Map({
      container: mapElement,
      style: "https://tiles.openfreemap.org/styles/liberty",
      center: [lng, lat],
      zoom: zoom,
    });

    new maplibregl.Marker().setLngLat([lng, lat]).addTo(mapInstance);
  }
};
